import React from 'react';

import { ISanityItemOptionModifier } from '@rbi-ctg/menu';
import ModifierPrice from 'components/menu-order-wizard/modifier-price';

import { BooleanOptionContainer, HiddenInput } from './styled';

interface IProps {
  index: number;
  options: ISanityItemOptionModifier[];
  onChange(index: number): void;
  price: number;
  'data-testid'?: string;
}

/** @deprecated Use ProductListItem with a Checkbox control instead */
export const MenuOptionBoolean = React.memo(
  ({ index, options, onChange, 'data-testid': dataTestId, price }: IProps) => {
    const disabled = options.length !== 2;

    return (
      <BooleanOptionContainer data-testid={dataTestId}>
        {options.map((option, i) => {
          const name = option.name?.locale;
          return (
            <React.Fragment key={option._key}>
              <HiddenInput
                type="radio"
                id={name}
                checked={index === i}
                value={name}
                disabled={disabled}
                onChange={() => {
                  onChange(i);
                }}
              />
              <label htmlFor={name} data-testid={name}>
                {name}
              </label>
            </React.Fragment>
          );
        })}
        <ModifierPrice price={price} />
      </BooleanOptionContainer>
    );
  }
);
